<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head" id="fm02-001"><b>ACKNOWLEDGMENTS</b></p>
<p class="txtt">My sincere thanks to Dawn Larsen, my internationally award-winning longarm quilter extraordinaire, without whom I would have only half the vision.</p>
<p class="txt">A big thank-you to Sue Henderson, my dear friend, without whom none of this would be possible. She remains my right hand and at times my left hand, too, keeping me grounded in so many ways when it is often hard to stay on a single path.</p>
<p class="txt">And—last but never least—thank you to Renee Nanneman, my dear friend, co-teacher, and quilting maven. With love and patience, she has taught me, guided me, and held my hand along the way.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_acknowledgement.vue?174cb2a8